// Barel export to easily import everything from '/folder' path

export { FolderModule } from './folder.module';
export { FolderService } from './folder.service';
export { FolderRoutingModule } from './folder-routing.module';



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/index.ts